import React from "react";
import { isObservableArray } from "mobx";
import { observer } from "mobx-react";
import {
  Button,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Fab
} from "@material-ui/core";

import { Add, ArrowDropDown, Delete, Edit } from "@material-ui/icons";

import { SIZE } from "../utils/Constants";

const styles = {
  actionButtonStyle: {
    position: "fixed",
    right: "30px",
    bottom: "40px"
  },
  topActionButtonStyle: {
    position: "fixed",
    right: "30px",
    bottom: "110px"
  },
  selectableRowStyle: {
    cursor: "pointer"
  },
  iconStyle: {
    height: "16px"
  },
  buttonStyle: {
    padding: "0",
    height: "16px",
    width: "32px"
  }
};

class TableCrud extends React.Component {
  getButtons = (selected, onEdit, onAdd, onDelete) => {
    let size = selected != null ? selected.length : 0;
    let buttons = [];
    if (size === 0 && onAdd) {
      buttons.push(
        <Fab
          color="primary"
          key={buttons.length}
          style={styles.actionButtonStyle}
          onClick={onAdd}
        >
          <Add />
        </Fab>
      );
    }
    if (size === 1 && onEdit) {
      buttons.push(
        <Fab
          color="primary"
          key={buttons.length}
          style={
            onDelete ? styles.topActionButtonStyle : styles.actionButtonStyle
          }
          onClick={onEdit}
        >
          <Edit />
        </Fab>
      );
    }
    if (size > 0 && onDelete) {
      buttons.push(
        <Fab
          color="primary"
          key={buttons.length}
          style={styles.actionButtonStyle}
          onClick={onDelete}
        >
          <Delete />
        </Fab>
      );
    }
    return buttons;
  };

  getRows = (data, columns, selected, onEdit, showCheckbox) =>
    data.map((item, i) => (
      <TableRow
        style={onEdit ? styles.selectableRowStyle : {}}
        onDoubleClick={() => this.onDoubleClick(selected, item, onEdit)}
        key={i}
      >
        { showCheckbox &&
          <TableCell padding="checkbox">
            <Checkbox
              checked={selected != null && selected.indexOf(item) >= 0}
              onChange={(event, checked) => this.onSelect(item, checked)}
            />
          </TableCell>
        }
        {columns.map((c, i) => {
          var value = item;
          c.field.split(".").forEach(column => {
            value = value[column] != null ? value[column] : "";
          }, value);
          return (
            <TableCell align={c.align ? c.align : "left"} key={i}>
              {c.func
                ? c.func(value)
                : isObservableArray(value) || Array.isArray(value)
                ? value.map(i => i[c.name]).join(", ")
                : value}
            </TableCell>
          );
        })}
      </TableRow>
    ));

  onSelectAll = (event, checked) => {
    let { selected, data } = this.props;
    if (checked) {
      selected.replace(data);
    } else {
      selected.clear();
    }
  };

  onSelect = (item, checked) => {
    let { selected } = this.props;
    if (checked) {
      selected.push(item);
    } else {
      selected.remove(item);
    }
  };

  onDoubleClick = (selected, item, onEdit) => {
    if (onEdit) {
      selected.length = 0;
      selected.push(item);
      onEdit();
    }
  };

  handleSorting = id => {
    let { store } = this.props;
    if (store !== null) {
      if (store.sort.column === id) {
        store.sort.ascending = !store.sort.ascending;
      } else {
        store.sort.column = id;
        store.sort.ascending = true;
      }
      if (store.page !== undefined) {
        store.page = 0;
      }
      store.query();
    }
  };

  handleNext = () => {
    let { store } = this.props;
    store.page++;
    store.query();
  };

  render() {
    let {
      data,
      selected,
      columns,
      onEdit,
      onAdd,
      onDelete,
      store,
      disableSort,
    } = this.props;
    let sort = null;
    if (store) {
      sort = store.sort;
    }
    let numSelected = selected ? selected.length : 0;
    let rowCount = data ? data.length : 0;
    return (
      <div>
        {this.getButtons(selected, onEdit, onAdd, onDelete)}
        {data.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                { (!!onEdit || !!onDelete) &&
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={numSelected > 0 && numSelected < rowCount}
                      checked={numSelected === rowCount}
                      onChange={this.onSelectAll}
                    />
                  </TableCell>
                }
                {columns.map((c, i) => (
                  <TableCell
                    key={i}
                    id={c.field}
                    align={c.align ? c.align : "left"}
                    sortDirection={
                      sort && store.sort.column === c.field
                        ? sort.ascending
                          ? "asc"
                          : "desc"
                        : false
                    }
                  >
                    {(sort && !disableSort) ? (
                      <TableSortLabel
                        active={sort.column === c.field}
                        direction={sort.ascending ? "asc" : "desc"}
                        onClick={() => this.handleSorting(c.field)}
                        IconComponent={ArrowDropDown}
                      >
                        {c.label}
                      </TableSortLabel>
                    ) : (
                      c.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.getRows(data, columns, selected, onEdit, !!onEdit || !!onDelete)}
            </TableBody>
          </Table>
        ) : (
          ""
        )}
        {store !== undefined &&
        store.page !== undefined &&
        data.length % SIZE === 0 &&
        data.length > 0 ? (
          <Button onClick={this.handleNext}>Mais resultados...</Button>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default observer(TableCrud);
